// components/PageWipe.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageWipe() {
  const { pathname } = useLocation();

  const play = () => {
    const el = document.getElementById('page-wipe');
    if (!el) return;
    // reset animation so it can replay
    el.classList.remove('play');
    // force reflow to flush the removal
    // (any read like offsetWidth works)
    // eslint-disable-next-line no-unused-expressions
    el.offsetWidth;
    el.classList.add('play');
    const onEnd = () => el.classList.remove('play');
    el.addEventListener('animationend', onEnd, { once: true });
  };

  // initial load
  useEffect(() => { play(); }, []);

  // every route change
  useEffect(() => { play(); }, [pathname]);

  return null;
}
